import Hero from './components/Hero';
import Features from './components/Features';
import Security from './components/Security';
import HowItWorks from './components/HowItWorks';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <Hero />
      <Features />
      <Security />
      <HowItWorks />
      <CTA />
      <Footer />
    </div>
  );
}
